var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcResMaintenanceGuides(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.471 12.9174L15.471 11.1174C16.1044 10.7374 16.8956 10.7374 17.529 11.1174L20.529 12.9174C21.1314 13.2788 21.5 13.9299 21.5 14.6324V17.3676C21.5 18.0701 21.1314 18.7212 20.529 19.0826L17.529 20.8826C16.8956 21.2626 16.1044 21.2626 15.471 20.8826L12.471 19.0826C11.8686 18.7212 11.5 18.0701 11.5 17.3676V14.6324C11.5 13.9299 11.8686 13.2788 12.471 12.9174Z",
    stroke: "#909090",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1992 4.89844V6.69844C13.2006 7.17539 13.3907 7.6324 13.728 7.96966C14.0653 8.30691 14.5223 8.49701 14.9992 8.49844H16.7992",
    stroke: "#909090",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19.4999H7.5C4.35 19.4999 2.5 17.6999 2.5 14.9999V7C2.5 4.3 4.35 2.5 7.5 2.5H14.7C17.85 2.5 19.2 4.3 19.2 7V9.49994",
    stroke: "#909090",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.5996C17.2732 14.5996 17.9004 15.2268 17.9004 16C17.9004 16.7732 17.2732 17.4004 16.5 17.4004C15.7268 17.4004 15.0996 16.7732 15.0996 16C15.0996 15.2268 15.7268 14.5996 16.5 14.5996Z",
    stroke: "#909090",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResMaintenanceGuides);
export default __webpack_public_path__ + "static/media/ic_res_maintenance_guides.b9c5f2adc00f55954c6874297f0262a8.svg";
export { ForwardRef as ReactComponent };